import * as React from "react";
import { formatMessage } from "lib/globalize-util";
import { IAllocationDimension } from "helpers/allocation-dimension";
import { styles } from "./styles";
import { ExportUpcCollection } from "./export-upc-collection";
import { AlertDialog } from "components/dialog/alert";

interface IProps {
    collectionName: string;
    allocationDimensions?: IAllocationDimension[];
    collectionExport: any;
    onClose: () => void;
    onExport: (params) => void;
}

export const ExportCollectionUpcDialog: React.FC<IProps> = ({
    allocationDimensions = [],
    collectionExport,
    onClose,
    onExport,
    collectionName,
}) => {
    return (
        <AlertDialog
            dismissButton={false}
            onRequestClose={onClose}
            open={true}
            title={<h3 style={styles.dialogTitle}>{formatMessage("Export UPCs")}</h3>}
            contentStyle={{ maxWidth: "600px" }}
        >
            <ExportUpcCollection
                collectionName={collectionName}
                allocationDimensions={allocationDimensions}
                collectionExport={collectionExport}
                onClose={onClose}
                onExport={onExport}
            />
        </AlertDialog>
    );
};
